<template lang="pug">
.initializer
  .load-container.flex-centered
    .loading.loading-lg
</template>

<script>
import authManager from '@/lib/AuthManager'
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('user', ['currentUser']),
  },

  methods: {
    ...mapActions('user', ['fetchCurrentUser']),
  },

  async created() {
    if (authManager.token()) {
      try {
        await this.fetchCurrentUser()

        this.$router.replace({ name: 'home' })
      } catch (e) {
        this.$toaster.error(e.message)
        authManager.logOff()
        this.$router.replace({ name: 'auth.signIn' })
      }
    } else {
      this.$router.replace({ name: 'auth.signIn' })
    }
  },
}
</script>

<style lang="stylus" scoped>
@import '../styles/_colors.styl'
.loading::after
  border 0.1rem solid primary
  border-top-color transparent
  border-top-style solid
  border-top-width 0.1rem
  border-right-color transparent
  border-right-style solid
  border-right-width 0.1rem
  border-bottom-color primary
  border-bottom-style solid
  border-bottom-width 0.1rem
  border-left-color primary
  border-left-style solid
  border-left-width 0.1rem
  border-image-source initial
  border-image-slice initial
  border-image-width initial
  border-image-outset initial
  border-image-repeat initial

.initializer
  background-color background
  height 100vh
  display flex
  flex-direction column

  .load-container
    flex 1
</style>
